import Section from './Section.jsx';

export default function MarineConditions({ note, buoys, defaultOpen }) {
  if (!note && !buoys?.length) return null;
  return (
    <Section title="Marine forecast" eyebrow="On the water" collapsible defaultOpen={defaultOpen}>
      {note && <p className="mb-4 leading-relaxed">{note}</p>}
      {buoys?.length > 0 && (
        <div className="grid gap-2 sm:grid-cols-2">
          {buoys.map((b) => (
            <div key={b.id} className="rounded-lg bg-cream-100 px-3 py-2.5">
              <div className="mb-1 text-xs uppercase tracking-wide text-navy-500">
                Buoy {b.id} · {b.name}
              </div>
              <div className="text-sm text-navy-800">
                {b.windDir} {b.windKt} kt · {b.waveFt} ft @ {b.periodSec}s · {b.waterTempF}°
              </div>
            </div>
          ))}
        </div>
      )}
    </Section>
  );
}
